// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2S7Qq","label":"Section_label__3ZtZ1","contentWrap":"Section_contentWrap__3JVv1","footer":"Section_footer__3s4T5","footerInner":"Section_footerInner__3uAUE"};